import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import React from 'react';

import useFunctionalityIconSelect from './functionality-icon-select.controller';

export interface FunctionalityIconSelectProps extends Omit<SelectInputV2Props<string>, 'options'> {
    subset?: string[];
}

export const FunctionalityIconSelect = (props: FunctionalityIconSelectProps) => {
    const viewProps = useFunctionalityIconSelect({ iconType: 'icon', subset: props.subset });

    return (
        <SelectInputV2
            {...props}
            options={viewProps.options}
        />
    );
};

export const FunctionalitySubIconSelect = (props: FunctionalityIconSelectProps) => {
    const viewProps = useFunctionalityIconSelect({ iconType: 'subicon', subset: props.subset });

    return (
        <SelectInputV2
            {...props}
            options={viewProps.options}
        />
    );
};

export default FunctionalityIconSelect;
